// extracted by mini-css-extract-plugin
export default {"profileInfo":"ProfilePage_profileInfo__C8Aas","grid":"ProfilePage_grid__VRaIU","gridItem":"ProfilePage_gridItem__f0d+Q"};